import { useContext, useEffect } from 'react';
import { ABeagleContext } from '../../contexts';
import { attachClientTimeSpentHandler } from '../../analytics/client-event-tracking';


/**
 * Serves the purpose of rolling out TimeSpentTracking. Once fully rolled out, we will remove this.
 */
export default function TimeSpentTracking({account}) {
  const { experiments, getExperimentValue } = useContext(ABeagleContext);

  useEffect(() => {
    if (!account) { return; }
    let time_spent_handler = () => {};
    if (!experiments.stale && experiments.loaded) {
      const variant = getExperimentValue('TimeSpentRO_4', { rejectErrors: false });
      if (variant === 'on') {
        time_spent_handler = attachClientTimeSpentHandler(account);
      }
    }
    return time_spent_handler;
  }, [experiments.loaded, experiments.stale, getExperimentValue, account]);

  return null;
}
